function openTab(evt, index, prefix) {
  const verticalTabNavigation = document.getElementById(
    `${prefix}vertical-tabnavigation`,
  );
  console.log(verticalTabNavigation);
  console.log(`tabcontent-${prefix}${index}`);
  if (!evt.currentTarget.className.includes("active")) {
    document
      .getElementById(`tabcontent-${prefix}${index}`)
      .classList.add("active");
    evt.currentTarget.classList.add("active");
    return;
  }

  document
    .getElementById(`tabcontent-${prefix}${index}`)
    .classList.remove("active");
  evt.currentTarget.classList.remove("active");
}

/* Reveal the .click-to-open the button actually sits in, rather than looking it
   up inside #vertical-tabnavigation. PDP-2026 renders the spoiler in
   .pdp-overview__body, outside that container — the element id still exists, so
   the old lookup found it, returned null for the inner query and threw
   "Cannot read properties of null", leaving the button dead. Also fixes the
   case of more than one spoiler on a page, which the old version could not
   address. */
function clickToReveal(evt) {
  evt.currentTarget.closest(".click-to-open")?.classList.add("active");
}
